import React from 'react'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useChangeSettingMutation } from '../../../redux/apiSlices/requestSlice';


function Setting() {

  const navigate = useNavigate()

  const [changeSetting, { isLoading }] = useChangeSettingMutation();

  
  const [applyingAvailable, setApplyingAvailable] = useState('opened');
  const [applyingPeriod, setApplyingPeriod] = useState(365);
 

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    let settingObj = {
      applying_available:applyingAvailable === 'opened' ? true : false,
      applying_period:applyingPeriod,
    }
    console.log(settingObj)
    try {
      await changeSetting(settingObj).unwrap()
      navigate('/')

    } catch (err) {
        console.error('Failed to save the changes', err)
    }
  }

  return (
    <div class="page-content-wrapper border">

    {/* <!-- Title --> */}
    <div class="row mb-3">
      <div class="col-12 d-sm-flex justify-content-between align-items-center">
        <h1 class="h3 mb-2 mb-sm-0">تغيير إعدادت المنصة</h1>
      </div>
    </div>
          {/* <!-- Card body START --> */}
          <div class="card bg-transparent">
          <div class="card-body">
          <form class="" onSubmit={handleSubmit}>
            {/* <!-- user type --> */}
								 <div class=" my-4">
                                    <span class="d-block mb-3">هل التقديم متاح</span>
										<div class="btn-group" role="group" aria-label="Basic radio toggle button group">
											{/* <!-- Free button --> */}
											<input type="radio" class="btn-check" name="type" id="add-type-1" value='opened' checked={applyingAvailable==='opened'} onChange={(e)=>setApplyingAvailable(e.target.value)}/>
											<label class="btn btn-sm btn-light btn-primary-soft-check border-0 m-0" htmlFor="add-type-1">متاح</label>
											{/* <!-- Premium button --> */}
											<input type="radio" class="btn-check" name="type" id="add-type-2" value='closed' checked={applyingAvailable==='closed'} onChange={(e)=>setApplyingAvailable(e.target.value)}/>
											<label class="btn btn-sm btn-light btn-primary-soft-check border-0 m-0" htmlFor="add-type-2">غير متاح</label>
										</div>
									</div>
                  <div class="col-4 mb-4">
									<label htmlFor="first-name" class="form-label">فترة اتاحة تقديم جديد</label>
									<div class="input-group input-group-lg">
										<input 
											type="number" 
											class="form-control border-0 bg-light rounded-end px-3 dr-rtl" 
											onChange={(e)=>setApplyingPeriod(e.target.valueAsNumber)}
											value={applyingPeriod}
											required
											/>
									</div>
								</div>
            
            {/* <!-- Button --> */}
            <div class="d-flex justify-content-end">
              {isLoading ?
                <button class="btn btn-primary" type="button" disabled>
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  يتم التحميل...
                </button> 
              :
              <button type="submit" class="btn btn-primary mb-0">حفظ التغيير</button>
              }
            </div>
           
          </form>
          </div>
          </div>
          {/* <!-- Card body END --> */}
        </div>
  )
}

export default Setting